import { useEffect, useState } from 'react';

/** Re-render every `ms` (relative times, truck positions). */
export function useTick(ms: number) {
  const [, set] = useState(0);
  useEffect(() => {
    const t = window.setInterval(() => set((n) => n + 1), ms);
    return () => window.clearInterval(t);
  }, [ms]);
}
